import React from 'react';
import { Link } from "react-router-dom";

// import Logo from '../../Assets/Images/logo.png';
import Logo from '../../Assets/Images/logo-snapshot.png';
import churchHealthLogo from '../../Assets/Images/logo-health.svg';
import snapshotMobileLogo from '../../Assets/Images/logo-snapshot-mobile.png';
import bleatLogo from '../../Assets/Images/logo-bleat.svg';
import bleatLogoMobile from '../../Assets/Images/logo-bleat-mobile.svg';
import useWindowDimensions from '../../Hooks/useWindowDimensions';

const Header = props => {

  const { windowWidth } = useWindowDimensions();

  return (
    <>
      <header>
        <div className="header-wrapper">
        
          {windowWidth > 830 ? <Link to="/start" className="logo"><img src={Logo} alt="Logo" /></Link> : <Link to="/start" className="logo"><img src={snapshotMobileLogo} alt="Logo" /></Link>}
          
          <div className="assessment-title desktop" id="assessment-title">
            <p className="logo-text">Your Giving Growth</p>
            <p className="logo-subtext">ASSESSMENT</p>
          </div>

          { windowWidth > 830 &&
            <div className="bleat-logo"><img src={bleatLogo} alt="bleat logo" height="57px" width="50px" /></div>
          }

        {/* {windowWidth <= 830 ?
          (<div className="bleat-logo-mobile">
            <img src={bleatLogoMobile} alt="bleat logo" height="43px" width="auto" />
          </div>) : (<div className="bleat-logo"><img src={bleatLogo} alt="bleat logo" height="57px" width="50px" /></div>)} */}

        </div>

      </header>
    </>
  )
}

export default Header;
